/**
 * Shopify Product Page JavaScript
 * Handles product image gallery, variant selection, and add to cart functionality
 */

document.addEventListener("DOMContentLoaded", function () {
  // Initialize product functionality
  initProductGallery();
  initVariantSelector();
  initColorSwatches();
  initSizeSwatches();
  initAddToCart();
  initQuantitySelector();

  /**
   * Initialize product image gallery with thumbnail navigation
   */
  function initProductGallery() {
    const mainImage = document.getElementById("mainImage");
    const thumbCarousel = document.getElementById("thumbCarousel");

    if (!mainImage || !thumbCarousel) return;

    // Handle thumbnail clicks
    thumbCarousel.addEventListener("click", function (e) {
      if (e.target.tagName === "IMG") {
        const fullImageUrl = e.target.dataset.full || e.target.src;
        mainImage.src = fullImageUrl;
        mainImage.alt = e.target.alt;

        // Update active thumbnail
        const thumbnails = thumbCarousel.querySelectorAll("img");
        thumbnails.forEach((thumb) => thumb.classList.remove("active"));
        e.target.classList.add("active");
      }
    });

    // Initialize Owl Carousel if available
    if (typeof $ !== "undefined" && $.fn.owlCarousel) {
      $("#thumbCarousel").owlCarousel({
        items: 4,
        margin: 8,
        nav: true,
        dots: false,
        responsive: {
          0: { items: 3 },
          576: { items: 4 },
        },
      });
    } else {
      // Fallback for when jQuery/Owl Carousel is not available
      console.log("Owl Carousel not available, using basic gallery");
    }
  }

  /**
   * Initialize variant selector functionality
   */
  function initVariantSelector() {
    const variantSelector = document.getElementById("variant-selector");
    const variantIdInput = document.getElementById("variant-id");
    const priceMain = document.querySelector("#selectedPrice");
    const comparePrice = document.querySelector(".retail_price");
    const mainImage = document.getElementById("mainImage");
    const thumbCarousel = document.getElementById("thumbCarousel");

    if (!variantSelector) return;

    variantSelector.addEventListener("change", function () {
      const selectedVariantId = this.value;
      const selectedOption = this.options[this.selectedIndex];

      // Update hidden input
      if (variantIdInput) {
        variantIdInput.value = selectedVariantId;
      }

      // Update price display
      // if (priceMain) {
      //   const parts = selectedOption.textContent.split("-");
      //   if (parts.length > 1) {
      //     const priceText = parts[parts.length - 1].trim();
      //     priceMain.textContent = priceText;
      //   }
      // }

      // Update compare at price if available
      // if (comparePrice) {
      //   // This would typically come from Shopify's variant data
      //   // For now, we'll keep it static
      // }

       // Update price dynamically from Shopify
  updatePriceWithQuantityAjax();

  // Listen for qty change

      // Update add to cart button state
      updateAddToCartButton(selectedOption.disabled);

      // Update images based on selected variant
      updateImagesForVariant(selectedVariantId, mainImage, thumbCarousel);
    });
  }

  /**
   * Initialize color swatch selection
   */
  function initColorSwatches() {
    const colorSwatches = document.getElementById("colorSwatches");
    const variantSelector = document.getElementById("variant-selector");
    const mainImage = document.getElementById("mainImage");
    const thumbCarousel = document.getElementById("thumbCarousel");

    if (!colorSwatches) return;

    colorSwatches.addEventListener("click", function (e) {
      if (e.target.classList.contains("color-swatch")) {
        // Remove selected class from all swatches
        const swatches = colorSwatches.querySelectorAll(".color-swatch");
        swatches.forEach((swatch) => swatch.classList.remove("selected"));

        // Add selected class to clicked swatch
        e.target.classList.add("selected");

        const selectedColor = e.target.dataset.color;

        // Update variant selector if it exists
        if (variantSelector) {
          updateVariantSelectorForColor(selectedColor);
        }

        // Update gallery images based on selected color
        updateGalleryForColor(selectedColor, mainImage, thumbCarousel);
      }
    });
  }

  /**
   * Update gallery images based on selected color
   */
  function updateGalleryForColor(color, mainImage, thumbCarousel) {
    if (!mainImage || !thumbCarousel) return;

    // Find the variant that matches the selected color
    const variantSelector = document.getElementById("variant-selector");
    if (!variantSelector) return;

    // Get all variant options
    const options = variantSelector.querySelectorAll("option");
    let selectedVariant = null;

    // Find the first variant that matches the selected color
    options.forEach((option) => {
      if (option.textContent.toLowerCase().includes(color.toLowerCase())) {
        if (!selectedVariant) {
          selectedVariant = option.value;
        }
      }
    });

    if (!selectedVariant) return;

    // Simply trigger the variant selector change to update images
    // This will use Shopify's built-in variant image switching
    variantSelector.value = selectedVariant;
    const event = new Event("change");
    variantSelector.dispatchEvent(event);
  }

  /**
   * Update images based on selected variant
   */
  function updateImagesForVariant(variantId, mainImage, thumbCarousel) {
    if (!mainImage || !thumbCarousel) return;

    // Fetch product data to get variant images
    const productHandle = window.location.pathname.split("/").pop();

    fetch(`/products/${productHandle}.js`)
      .then((response) => response.json())
      .then((product) => {
        // Find the selected variant
        const variant = product.variants.find(
          (v) => v.id.toString() === variantId
        );

        if (variant) {
          // Update main image with variant's featured image if available
          if (variant.featured_image) {
            mainImage.src = variant.featured_image.src;
            mainImage.alt = variant.featured_image.alt || product.title;
          }

          // Update thumbnail carousel
          const carouselItems = thumbCarousel.querySelectorAll(".item");

          // Use variant images if available, otherwise use product images
          const imagesToUse =
            variant.images && variant.images.length > 0
              ? variant.images
              : product.images;

          carouselItems.forEach((item, index) => {
            const img = item.querySelector("img");
            if (img && imagesToUse[index]) {
              const imageUrl = imagesToUse[index].src || imagesToUse[index];
              // Use smaller size for thumbnails
              const thumbnailUrl = imageUrl.replace(
                /\.(jpg|jpeg|png|gif|webp)/,
                "_150x.$1"
              );
              img.src = thumbnailUrl;
              img.dataset.full = imageUrl;
              img.alt = imagesToUse[index].alt || product.title;
            }
          });

          // Reinitialize Owl Carousel if needed
          if (typeof $ !== "undefined" && $.fn.owlCarousel) {
            $("#thumbCarousel").trigger("refresh.owl.carousel");
          }
        }
      })
      .catch((error) => {
        console.error("Error updating variant images:", error);
      });
  }

  /**
   * Initialize size swatch selection
   */
  function initSizeSwatches() {
    const sizeSwatches = document.getElementById("sizeSwatches");

    if (!sizeSwatches) return;

    sizeSwatches.addEventListener("click", function (e) {
      if (e.target.classList.contains("size-swatch")) {
        // Remove active class from all size swatches
        const swatches = sizeSwatches.querySelectorAll(".size-swatch");
        swatches.forEach((swatch) => {
          swatch.classList.remove("btn-primary");
          swatch.classList.add("btn-outline-secondary");
        });

        // Add active class to clicked swatch
        e.target.classList.remove("btn-outline-secondary");
        e.target.classList.add("btn-primary");

        // Update variant selector if it exists
        const selectedSize = e.target.dataset.size;
        updateVariantSelectorForSize(selectedSize);
      }
    });
  }

  /**
   * Update variant selector based on selected color
   */
  function updateVariantSelectorForColor(color) {
    const variantSelector = document.getElementById("variant-selector");
    if (!variantSelector) return;

    // Find variants that match the selected color
    const options = variantSelector.querySelectorAll("option");
    let foundMatch = false;

    options.forEach((option) => {
      if (option.textContent.toLowerCase().includes(color.toLowerCase())) {
        if (!foundMatch) {
          option.selected = true;
          foundMatch = true;
          // Trigger change event
          const event = new Event("change");
          variantSelector.dispatchEvent(event);
        }
      }
    });
  }

  /**
   * Update variant selector based on selected size
   */
  function updateVariantSelectorForSize(size) {
    const variantSelector = document.getElementById("variant-selector");
    if (!variantSelector) return;

    // Find variants that match the selected size
    const options = variantSelector.querySelectorAll("option");
    let foundMatch = false;

    options.forEach((option) => {
      if (option.textContent.toLowerCase().includes(size.toLowerCase())) {
        if (!foundMatch) {
          option.selected = true;
          foundMatch = true;
          // Trigger change event
          const event = new Event("change");
          variantSelector.dispatchEvent(event);
        }
      }
    });
  }

  /**
   * Initialize add to cart functionality
   */
  function initAddToCart() {
    const addToCartForm = document.getElementById("product-form");

    if (!addToCartForm) return;

    addToCartForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // alert('hi'); return;

      const formData = new FormData(this);
      const submitButton = this.querySelector(".add-to-cart-btn");

      // Disable button during submission
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Adding...";
      }

      // Submit to Shopify cart
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Success - update cart count and show success message
          updateCartCount();
          showSuccessMessage("Product added to cart!");

          // Re-enable button
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = "Add to Cart";
          }
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          showErrorMessage("Error adding product to cart. Please try again.");

          // Re-enable button
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = "Add to Cart";
          }
        });
    });
  }

  /**
   * Initialize quantity selector
   */
  function initQuantitySelector() {
    const quantityInput = document.getElementById("quantity");

    if (!quantityInput) return;

    // Ensure quantity is at least 1
    quantityInput.addEventListener("change", function () {
      if (this.value < 1) {
        this.value = 1;
      }
    });

    // Prevent non-numeric input
    quantityInput.addEventListener("keypress", function (e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    });
  }

  /**
   * Update add to cart button state
   */
  function updateAddToCartButton(isDisabled) {
    const addToCartBtn = document.querySelector(".add-to-cart-btn");

    if (!addToCartBtn) return;

    if (isDisabled) {
      addToCartBtn.disabled = true;
      addToCartBtn.textContent = "Sold Out";
      addToCartBtn.classList.add("btn-secondary");
      addToCartBtn.classList.remove("btn-primary");
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = "Add to Cart";
      addToCartBtn.classList.add("btn-primary");
      addToCartBtn.classList.remove("btn-secondary");
    }
  }

  /**
   * Update cart count in header (if cart count element exists)
   */
  function updateCartCount() {
    // This would typically update a cart count badge in the header
    // Implementation depends on your theme's cart count element
    const cartCountElement = document.querySelector(".cart-count");
    if (cartCountElement) {
      // Fetch updated cart count from Shopify
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          cartCountElement.textContent = cart.item_count;
        });
    }
  }

  /**
   * Show success message
   */
  function showSuccessMessage(message) {
    // Create or update success message element
    let messageElement = document.getElementById("product-message");
    if (!messageElement) {
      messageElement = document.createElement("div");
      messageElement.id = "product-message";
      messageElement.className = "alert alert-success mt-3";
      document
        .getElementById("product-form")
        .parentNode.appendChild(messageElement);
    }

    messageElement.textContent = message;
    messageElement.style.display = "block";

    // Hide message after 3 seconds
    setTimeout(() => {
      messageElement.style.display = "none";
    }, 3000);
  }

  /**
   * Show error message
   */
  function showErrorMessage(message) {
    // Create or update error message element
    let messageElement = document.getElementById("product-message");
    if (!messageElement) {
      messageElement = document.createElement("div");
      messageElement.id = "product-message";
      messageElement.className = "alert alert-danger mt-3";
      document
        .getElementById("product-form")
        .parentNode.appendChild(messageElement);
    }

    messageElement.textContent = message;
    messageElement.className = "alert alert-danger mt-3";
    messageElement.style.display = "block";

    // Hide message after 5 seconds
    setTimeout(() => {
      messageElement.style.display = "none";
    }, 5000);
  }

  /**
   * Initialize accordion functionality (if Bootstrap is not loaded)
   */
  function initAccordion() {
    const accordionButtons = document.querySelectorAll(".accordion-button");

    accordionButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const targetId = this.getAttribute("data-bs-target");
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          const isExpanded = targetElement.classList.contains("show");

          // Close all accordion items
          document.querySelectorAll(".accordion-collapse").forEach((item) => {
            item.classList.remove("show");
          });

          // Open clicked item if it wasn't already open
          if (!isExpanded) {
            targetElement.classList.add("show");
          }
        }
      });
    });
  }

  // Initialize accordion if Bootstrap is not available
  if (typeof bootstrap === "undefined") {
    initAccordion();
  }


  document.getElementById("quantity")?.addEventListener("input", updatePriceWithQuantityAjax);


document.addEventListener("input", function(e) {
  if (
    e.target.matches('input[name="properties[_Area_x]"]') ||
    e.target.matches('input[name="properties[_Area_y]"]')
  ) {
   updatePriceWithQuantityAjax();
  }
});

document.addEventListener("click", function(e) {
  if (e.target.closest(".cl-po--quantity-btn")) {
    updatePriceWithQuantityAjax();
  }
});

document.addEventListener("change", function (e) {
  if (e.target.matches('input.cl-po--input[type="checkbox"]')) {
    updatePriceWithQuantityAjax();
  }
});

function showLoadingSpan(priceMain) {
  console.log('start loading');
  let loadingSpan = document.getElementById("priceLoading");

  // Create span only once
  if (!loadingSpan) {
    loadingSpan = document.createElement("span");
    loadingSpan.id = "priceLoading";
    loadingSpan.style.marginLeft = "8px";
    loadingSpan.style.fontSize = "14px";
    loadingSpan.style.opacity = "0.7";
    priceMain.insertAdjacentElement("afterend", loadingSpan);
  }

  loadingSpan.textContent = "Calculating...";
}

function hideLoadingSpan() {
  console.log('stop loading');
  const loadingSpan = document.getElementById("priceLoading");
  if (loadingSpan) loadingSpan.textContent = "";
}



function updatePriceWithQuantityAjax() {
  // console.log('hi');
  extractPriceDiscount();
  const variantSelector = document.getElementById("variant-selector");
  const priceMain = document.querySelector("#selectedPrice");
  const quantityInput = document.getElementById("quantity");

  if (!priceMain || !quantityInput) return;

  showLoadingSpan(priceMain);

   const qty = parseInt(quantityInput.value, 10) || 1;

  //  console.log(priceMain,qty);

  if(variantSelector){
  const selectedVariantId = variantSelector.value;
 

  fetch(`/variants/${selectedVariantId}.js`)
    .then(res => res.json())
    .then(variant => {
      let totalPrice = (variant.price / 100) * qty; // convert cents to currency

      // Apply volume discount
      totalPrice = applyVolumeDiscount(totalPrice);

      // Use Shopify’s locale/currency to format correctly
      const formatted = new Intl.NumberFormat(Shopify.locale, {
        style: "currency",
        currency: Shopify.currency.active
      }).format(totalPrice);

      priceMain.textContent = formatted;
        hideLoadingSpan();
    });
  }else{
  // ✅ Fetch product JSON for non-variant products
  fetch(`${window.location.pathname}.js`)
    .then(res => res.json())
    .then(product => {
      if (!product || !product.price) {
        priceMain.textContent = "N/A";
        return;
      }

     
const productId = product.id;

const areaX = parseFloat(document.querySelector('input[name="properties[_Area_x]"]').value) || 0;
const areaY = parseFloat(document.querySelector('input[name="properties[_Area_y]"]').value) || 0;

let totalPrice;

const customProducts = [6927157428272];

if (customProducts.includes(productId) && areaX > 0 && areaY > 0) {
  const area = areaX * areaY;
  const customPrice = area * 0.0416;
  totalPrice = customPrice * qty;
} else {
  totalPrice = (product.price / 100) * qty;
}

if (
  document.querySelector('input[name="properties[precut]"]')?.value
    ?.toLowerCase() === 'yes'
) {
  totalPrice += 0.25 * qty;
}



// let totalPrice = (product.price / 100) * qty; 




      // Apply volume discount
      totalPrice = applyVolumeDiscount(totalPrice);

      // Format with Shopify locale + currency
      const formatted = new Intl.NumberFormat(Shopify.locale, {
        style: "currency",
        currency: Shopify.currency.active
      }).format(totalPrice);

      priceMain.textContent = formatted;
        hideLoadingSpan();
    })
    .catch(() => {
      priceMain.textContent = "N/A";
       hideLoadingSpan();
    });
}



}



});



const priceDiscountData = [];



// Array to store structured price + discount data


// Function to extract prices and discounts
function extractPriceDiscount() {
  const priceEls = document.querySelectorAll('.discounty-volume-discount-widget__criteria');
  const discountEls = document.querySelectorAll('.discounty-volume-discount-widget__discount');

  // Only proceed if we have both
  if (priceEls.length && discountEls.length) {
    priceEls.forEach((el, index) => {
      // Extract numeric price
      let priceText = el.textContent.trim(); // e.g., "₹2,120.38+"
      let price = parseFloat(priceText.replace(/[^0-9.]/g, ''));

      // Extract numeric discount
      let discountText = discountEls[index]?.textContent.trim() || '';
      let discount = parseFloat(discountText.replace(/[^0-9.]/g, ''));

      if (!isNaN(price)) {
        priceDiscountData[index] = {
          price: price,
          discount: !isNaN(discount) ? discount : 0
        };
      }
    });
// console.log(priceDiscountData);
  }
}

// Observe the body for dynamically added nodes
const observer = new MutationObserver(() => {
  extractPriceDiscount();
});

// Start observing
observer.observe(document.body, { childList: true, subtree: true });



function applyVolumeDiscount(totalPrice) {
  // console.log(priceDiscountData);
  if (!priceDiscountData || !priceDiscountData.length) return totalPrice;

  let discountObj = null;
  for (let i = 0; i < priceDiscountData.length; i++) {
    if (totalPrice >= priceDiscountData[i].price) {
      discountObj = priceDiscountData[i];
    }
  }

  const disHtml = document.getElementById("disHtml");

  if (discountObj) {
    const discountedPrice = totalPrice * (1 - discountObj.discount / 100);
    const discountAmount = totalPrice - discountedPrice;

    console.log(
      `Discount applied: ${discountObj.discount}% (-${discountAmount.toFixed(2)})`
    );
    console.log("Final discounted price:", discountedPrice);

    if (disHtml) {
      disHtml.textContent = `You saved: ${new Intl.NumberFormat(Shopify.locale, {
        style: "currency",
        currency: Shopify.currency.active,
      }).format(discountAmount)}`;
    }

    return discountedPrice;
  } else {
    if (disHtml) {
      disHtml.textContent = ""; // remove content if no discount
    }
  }

  return totalPrice;
}



